export default {"src":"/_next/static/media/categories.d0956e24.svg","height":25,"width":25};